import { render, staticRenderFns } from "./updateTaskHistory.vue?vue&type=template&id=8d8e4122&scoped=true"
import script from "./updateTaskHistory.vue?vue&type=script&lang=js"
export * from "./updateTaskHistory.vue?vue&type=script&lang=js"
import style0 from "./updateTaskHistory.vue?vue&type=style&index=0&id=8d8e4122&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8e4122",
  null
  
)

export default component.exports